module.exports = __webpack_public_path__ + "static/media/subcategories.8d97840f.svg";